import { render, staticRenderFns } from "./DistributionMySecondListPage.vue?vue&type=template&id=84348ab6&scoped=true"
import script from "./DistributionMySecondListPage.vue?vue&type=script&lang=js"
export * from "./DistributionMySecondListPage.vue?vue&type=script&lang=js"
import style0 from "./DistributionMySecondListPage.vue?vue&type=style&index=0&id=84348ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84348ab6",
  null
  
)

export default component.exports